<template>
    <div class="pc-subject-wrapper" :class="[(big_img || img_url )&& 'hasTopImg',isRed && 'pc-subject-wrapper-red']">
        <div class="top-bg">
            <img v-if="big_img || img_url" :src="big_img || img_url" alt="">
        </div>
        <div class="subject-main">
            <!-- 有分类专题/专栏列表 -->
            <div class="top-category-container" v-if="showType === 0 || showType === 1">
                <div class="subject-title">{{ subject_name }}</div>
                <div class="subject-category" v-if="showType === 1">
                    <div class="subject-category-item" @click="scrollToCategory(item.category_id)" v-for="item in data" :key="item.category_id">{{ item.category_name }}</div>
                </div>
            </div>
            <div class="sub-item" v-if="showType === 1">
                <div class="sub-card" v-for="item in data" :key="item.category_id" :id="'category_' + item.category_id">
                    <NewsCardList :morePath="`${$route.path}/${item.category_id}`" v-if="item.news.length" :data="item.news.slice(0, 4)" :moduleInfo="{name: item.category_name}" :type="1"></NewsCardList>
                </div>
            </div>
            <!-- 无分类专题/专栏列表 -->
            <div class="list-container" v-if="showType === 0">
                <div class="sub-card">
                    <NewsCardList
                        :hideTitle="true"
                        :loading="loading" 
                        @getMoreData="getSubjectList" 
                        v-if="showType === 0" 
                        :data="list" 
                        :moduleInfo="{name: subject_name}"
                        :hasMore="hasMore"
                        :type="1" />
                </div>

            </div>
            <!-- 专题/专栏分类详情列表 -->
            <div class="list-container" v-if="showType === 2">
                <NewsCardList
                    :loading="loading" 
                    @getMoreData="getSubjectCategoryDetail" 
                    v-if="showType === 2" 
                    :data="list" 
                    :moduleInfo="{name: category_info.name}"
                    :hasMore="hasMore"
                    :type="1" />
            </div>
        </div>
    </div>
</template>
<script>
import NewsCardList from '@/components/pc/NewsCardList.vue'
import { mapState } from 'vuex'
export default {
    name: 'Subject',
    data() {
        return {
            subject_id: null,
            subject_type: null,
            subject_category_id: null,
            last_news_id: null,
            page_size: 12,
            subject_name: "",
            img_url: "",
            big_img: "",
            data: [],
            list: [],
            category_info:{
                name: "",
                id: 0,
            },
            showType: -1, //-1：初始化隐藏 0: 无分类专题/专栏列表 1: 有分类专题/专栏列表 2: 专题/专栏分类详情列表
            loading: false,
            hasMore: true,
        }
    },
    components: {
        NewsCardList
    },
    computed: {
        ...mapState(['isRed']),
    },
    watch: {
        '$route.params'(val){
            const {id, type, skId} = val
            this.clearData()
            this.subject_id = Number(id)
            this.subject_type = Number(type)
            this.subject_category_id = Number(skId)
            if (this.subject_type === 5 || this.subject_type === 13){
                this.showType = 0
            }
            if (this.subject_type === 30 || this.subject_type === 36){
                this.showType = 1
            }
            if (skId){
                this.showType = 2
            }
            if (this.showType === 0){
                this.getSubjectList(1)
            }
            if (this.showType === 1) {
                this.getSubjectInfo()
            }
            if (this.showType === 2){
                this.getSubjectCategoryDetail(1)
            }
        }
    },
    created() {
        const {id, type, skId} = this.$route.params
        // id: 专题/专栏id
        // type: 30,36 有分类专题/专栏列表 5,13 无分类专题/专栏列表
        // skId: 专题/专栏分类id
        this.subject_id = Number(id)
        this.subject_type = Number(type)
        this.subject_category_id = Number(skId)
        if (this.subject_type === 5 || this.subject_type === 13){
            this.showType = 0
        }
        if (this.subject_type === 30 || this.subject_type === 36){
            this.showType = 1
        }
        if (skId){
            this.showType = 2
        }
        if (this.showType === 0){
            this.getSubjectList(1)
        }
        if (this.showType === 1) {
            this.getSubjectInfo()
        }
        if (this.showType === 2){
            this.getSubjectCategoryDetail(1)
        }
    },
    mounted() {

    },
    methods: {
        // 点击自动滚动到对应分类
        scrollToCategory(category_id) {
            const category = document.getElementById(`category_${category_id}`)
            category && category.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest"
            })
        },
        // 获取无分类专题/专栏列表
        getSubjectList(page = 1) {
            const params = {
                subject_id: this.subject_id,
                channel_type: this.subject_type,
                page: page,
                page_size: this.page_size,
                listNewsKindIn: "[4,3,11,5,9,10,6]"
            }
            const payload = 'data=' + JSON.stringify(params)
            this.loading = true
            this.$axios.post(this.$ApiInfo.getSubject,payload,false).then(res => {
                this.loading = false
                const { list, subject_name, img_url, big_img } = (res || {})
                this.hasMore = list.length === this.page_size
                if (page === 1){
                    this.subject_name = subject_name
                    this.img_url = img_url
                    this.big_img = big_img
                    this.list = list
                }else{  
                    this.list = [...this.list, ...list]
                }
            })
        },
        // 获取有分类专题/专栏列表
        getSubjectInfo(){
            const params = {
                subject_id: this.subject_id
            }
            const payload = 'data=' + JSON.stringify(params)
            this.loading = true
            this.$axios.post(this.$ApiInfo.getSubjectTypeInfo, payload, false).then(res => {
                this.loading = false
                const { list, subject_name, img_url, big_img } = res
                this.subject_name = subject_name
                this.data = list
                this.img_url = img_url
                this.big_img = big_img
            })
        },
        // 获取分类详情
        getSubjectCategoryDetail(page = 1){
            const params = {
                news_id: this.last_news_id,
                subject_id: this.subject_id,
                category_id: this.subject_category_id,
                page: page,
                page_size: this.page_size,
                listNewsKindIn: "[4,3,11,5,9,10,6]"
            }
            const payload = 'data=' + JSON.stringify(params)
            this.loading = true
            this.$axios.post(this.$ApiInfo.getCategoryNews,payload,false).then(res => {
                this.loading = false
                const { news = [], category_name, last_news_id } = (res || {})
                this.hasMore = news.length === this.page_size
                this.last_news_id = last_news_id
                if (page === 1){
                    this.list = news
                    this.category_info = {name: category_name, id: this.subject_category_id}
                }else{  
                    this.list = [...this.list, ...news]
                }
            })
        },
        // 切换时清空数据
        clearData(){
            this.showType = -1
            this.hasMore = true
            this.data = []
            this.list = []
            this.img_url = ''
            this.big_img = ''
            this.last_news_id = null
            this.category_info = {}
        }
    },
}
</script>
<style lang="less">
.pc-subject-wrapper{
    min-height: 500px;
    padding-bottom: 30px;
    .top-bg{
        z-index: 0;
        top: 0px;
        position: absolute;
        left: 0;
        width: 100%;
        height: 169px;
        // background: linear-gradient(180deg, #006CB9 0%, rgba(0,108,185,0) 100%) no-repeat;
        img{
            width: 100%;
            max-width: 1920px;
            display: block;
            margin: 0 auto;
            height: 180px;
            object-fit: cover;
        }
    }
    &.hasTopImg{
        padding-top: 160px;
        .top-bg{
            height: 180px;
        }
    }
    .subject-main{
        margin-top: 20px;
        width: 1200px;
        .top-category-container{
            box-sizing: border-box;
            // min-height: 181px;
            background: #FFFFFF;
            // border-top: 4px solid #006CB9;
            box-sizing: border-box;
            padding: 25px 32px 24px;
            .subject-title{
                height: 37px;
                font-size: 24px;
                // font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                // font-weight: bold;
                color: #252E35;
                line-height: 37px;
                overflow: hidden;
                // margin-bottom: 10px;
            }
            .subject-category{
                overflow: hidden;
                margin-top: 20px;
                display: flex;
                flex-wrap: wrap;
                .subject-category-item{
                    box-sizing: border-box;
                    margin-right: 20px;
                    height: 40px;
                    background: #FFFFFF;
                    border-radius: 2px;
                    border: 1px solid rgba(0,0,0,0.15);
                    padding: 14px 32px;
                    font-size: 16px;
                    color: #333333;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 10px;
                    // width: 136px;
                    &:hover{
                        border: 1px solid #006CB9;
                    }
                    &:last-child{
                        margin-right: 0;
                    }
                }
            }
        }
        .sub-card{
            padding-top: 40px;
        }
        .list-container{
            margin-bottom: 60px;
        }
    }
}
.pc-subject-wrapper-red{

    .subject-main{
        .top-category-container{
            // border-top: 4px solid #B01F0B;
            .subject-category{
                .subject-category-item{
                    &:hover{
                        border: 1px solid #B01F0B;
                    }
                }
            }
        }
    }
}
</style>